import BenchlingConfig from 'BenchlingConfig';

interface DeleteUtilParams {
  isArchived: boolean;
}

export function getUndeletableTooltipTitle({isArchived}: DeleteUtilParams): string | null {
  if (!BenchlingConfig.ENABLE_DELETE) {
    return null;
  }
  if (!isArchived) {
    return 'Only archived items can be deleted';
  } else {
    return 'You do not have permissions to delete this item';
  }
}
